import { isHttpValid } from './url';
import { FSK_URL } from '../constants/fsk';

export function getFskPromoUrl({ isEmpty, hitUrl, erid }: { isEmpty: boolean; hitUrl: string; erid?: string }) {
  if (isEmpty) {
    return '#';
  }

  const preparedUrl = isHttpValid(hitUrl) ? hitUrl : FSK_URL;
  const url = new URL(preparedUrl);

  if (erid) {
    url.searchParams.append('erid', erid);
  }

  return url.href;
}
